"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Arbitrum = exports.Optimism = exports.Mumbai = exports.Matic = exports.Goerli = exports.Rinkeby = exports.Mainnet = exports.getTransactionLink = exports.getAddressLink = void 0;
var getAddressLink = function (explorerUrl) { return function (address) {
    return explorerUrl + "/address/" + address;
}; };
exports.getAddressLink = getAddressLink;
var getTransactionLink = function (explorerUrl) { return function (txnId) {
    return explorerUrl + "/tx/" + txnId;
}; };
exports.getTransactionLink = getTransactionLink;
var etherscanUrl = 'https://etherscan.io';
var rinkebyEtherscanUrl = 'https://rinkeby.etherscan.io';
var goerliEtherscanUrl = 'https://goerli.etherscan.io';
var optimismEtherscanUrl = 'https://optimistic.etherscan.io';
var arbitrumEtherscanUrl = 'https://arbiscan.io';
exports.Mainnet = {
    chainId: 1,
    chainName: 'Mainnet',
    isTestChain: false,
    isLocalChain: false,
    multicallAddress: '0xeefba1e63905ef1d7acba5a8513c70307c1ce441',
    multicall2Address: '0x5ba1e12693dc8f9c48aad8770482f4739beed696',
    blockExplorerUrl: etherscanUrl,
    getExplorerAddressLink: (0, exports.getAddressLink)(etherscanUrl),
    getExplorerTransactionLink: (0, exports.getTransactionLink)(etherscanUrl),
};
exports.Rinkeby = {
    chainId: 4,
    chainName: 'Rinkeby',
    isTestChain: true,
    isLocalChain: false,
    multicallAddress: '0x42ad527de7d4e9d9d011ac45b31d8551f8fe9821',
    multicall2Address: '0x5ba1e12693dc8f9c48aad8770482f4739beed696',
    blockExplorerUrl: rinkebyEtherscanUrl,
    getExplorerAddressLink: (0, exports.getAddressLink)(rinkebyEtherscanUrl),
    getExplorerTransactionLink: (0, exports.getTransactionLink)(rinkebyEtherscanUrl),
};
exports.Goerli = {
    chainId: 5,
    chainName: 'Goerli',
    isTestChain: true,
    isLocalChain: false,
    multicallAddress: '0x77dca2c955b15e9de4dbbcf1246b4b85b651e50e',
    multicall2Address: '0x5ba1e12693dc8f9c48aad8770482f4739beed696',
    blockExplorerUrl: goerliEtherscanUrl,
    getExplorerAddressLink: (0, exports.getAddressLink)(goerliEtherscanUrl),
    getExplorerTransactionLink: (0, exports.getTransactionLink)(goerliEtherscanUrl),
};
exports.Matic = {
    chainId: 137,
    chainName: 'Polygon',
    isTestChain: false,
    isLocalChain: false,
    multicallAddress: '0x11ce4B23bD875D7F5C6a31084f55fDe1e9A87507',
    getExplorerAddressLink: function (address) { return "https://polygonscan.com/address/" + address; },
    getExplorerTransactionLink: function (transactionHash) {
        return "https://polygonscan.com/tx/" + transactionHash;
    },
};
exports.Mumbai = {
    chainId: 80001,
    chainName: 'Mumbai',
    isTestChain: true,
    isLocalChain: false,
    multicallAddress: '0xca11bde05977b3631167028862be2a173976ca11',
    getExplorerAddressLink: function (address) { return "https://mumbai.polygonscan.com/address/" + address; },
    getExplorerTransactionLink: function (transactionHash) {
        return "https://mumbai.polygonscan.com/tx/" + transactionHash;
    },
};
exports.Optimism = {
    chainId: 10,
    chainName: 'Optimism',
    isTestChain: false,
    isLocalChain: false,
    multicallAddress: '0xca11bde05977b3631167028862be2a173976ca11',
    getExplorerAddressLink: (0, exports.getAddressLink)(optimismEtherscanUrl),
    getExplorerTransactionLink: (0, exports.getTransactionLink)(optimismEtherscanUrl),
};
exports.Arbitrum = {
    chainId: 42161,
    chainName: 'Arbitrum',
    isTestChain: false,
    isLocalChain: false,
    multicallAddress: '0xca11bde05977b3631167028862be2a173976ca11',
    getExplorerAddressLink: (0, exports.getAddressLink)(arbitrumEtherscanUrl),
    getExplorerTransactionLink: (0, exports.getTransactionLink)(arbitrumEtherscanUrl),
};
